import { useCallback } from "react";
import { startAdmissionRecheck, type BatchJob } from "../../../../../lib/corpusApi";
import type { BatchJobParamsForm } from "../../batch_job_kind_contract";
import { useDocumentScope, type DocumentScopeState } from "../../useDocumentScope";

export interface UseAdmissionRecheckParamsResult extends BatchJobParamsForm, DocumentScopeState {}

/** The params an admission_recheck job is started with: which documents to re-check. */
export function useAdmissionRecheckParams(): UseAdmissionRecheckParamsResult {
  const documentScope = useDocumentScope("pending_ready");
  const { scope } = documentScope;

  const start = useCallback(
    (name?: string): Promise<BatchJob> => startAdmissionRecheck({ scope, name }),
    [scope]
  );

  return { ...documentScope, canStart: true, start };
}
